// Webpack Imports
import 'bootstrap';
import 'slick-carousel';

require('./inc/header.js');
require('./inc/search.js');
require('./inc/forms.js');
require('./inc/testimonials.js');
require('./inc/team.js');
require('./inc/notification.js');
require('./inc/wp-navigation.js');
require('./inc/comments.js');
require('./inc/profile.js');
require('./inc/change-password.js');
require('./inc/gtm.js');

//Learndash 
require('./inc/course-list.js');
require('./inc/focus.js');
require('./inc/course-sidebar.js');
require('./inc/resource-hub.js');
require('./inc/calendar.js');